<template>
    <div class="flex items-center" :class="wrap ? 'flex-wrap gap-2' : 'space-x-2'">
        <activix-pill
            :is-active="activePill === pill.name"
            :is-disabled="pill.disabled"
            :label="pill.label"
            :tab-index="pillTabIndex"
            :size="size"
            :variant="variant"
            data-testid="pill"
            :key="pill.name"
            @click="onClick(pill)"
            v-for="pill in pills"
        />
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue';
    import { onMounted, ref, watch } from 'vue';
    import ActivixPill from '@/components/activix-ui/ActivixPills/ActivixPill.vue';
    import type { ActivixPillOption } from '@/components/activix-ui/ActivixPills/types.ts';

    defineOptions({ compatConfig: { COMPONENT_V_MODEL: false } });

    const props = defineProps({
        pills: {
            type: Array as PropType<ActivixPillOption[]>,
            required: true,
        },
        modelValue: {
            type: String,
            default: '',
        },
        pillTabIndex: {
            type: [Number, String],
            default: undefined,
        },
        wrap: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String as PropType<'md' | 'sm'>,
            default: 'md',
        },
        variant: {
            type: String as PropType<'neutral' | 'primary'>,
            default: 'neutral',
        },
    });

    const emit = defineEmits<{
        'update:modelValue': [activePill: string | null];
    }>();

    const activePill = ref<string | null>(props.modelValue as string | null);

    watch(activePill, (newActivePill) => {
        emit('update:modelValue', newActivePill);
    });

    watch(
        () => props.modelValue,
        (newValue) => {
            if (activePill.value !== newValue) {
                activePill.value = newValue as string | null;
            }
        }
    );

    const onClick = (pill: ActivixPillOption) => {
        if (pill.disabled) {
            return;
        }

        activePill.value = pill.name;
    };

    onMounted(() => {
        if (!props.modelValue) {
            activePill.value = props.pills[0]?.name || null;
        }
    });
</script>
